module.exports = __webpack_public_path__ + "img/1_1.8b06c330.jpg";